/**
 * @description 系统参数
 * @date 2023-10-30 15:24:09
 * @author 2028
 */
import { Api, getTenantApi, getUserDetailApi, refreshTokenApi, ssoAuthApi, jzAuthApi, getUserInfo, logout, getSSOConfig } from '@/api/serviceEip'
import router from '@/router'
import { getCache, setCache, removeCache } from '@/utils/cache'
import { cacheMode, eipToken, ssoConfigMap } from '@/config/constants.js'

export default {
  namespaced: true,
  state: {
    token: null, // 鉴权标识
    currentUser: null, // 当前登录用户
    isFirstLoad: true, // 是否首次加载
    isRefreshingToken: false, // 是否正在刷新token
    logo: '', // logo
    tenantCode: localStorage.getItem('tenantCode') || 'platform', // 租户code
    tenantId: localStorage.getItem('tenantId') || '-1', // 租户id
    currentUserDetail: null, // 用户详情
    ssoConfig: null, // 用户登录配置,
  },
  getters: {
    loginUrl(state) {
      return state.tenantCode === 'platform' ? '/login' : `/login/${state.tenantCode}`
    },
    token: state => state.token,
    currentUser: state => state.currentUser,
    ssoConfig: state => state.ssoConfig
  },
  mutations: {
    setToken(state, token){
      state.token = token
      setCache(cacheMode, eipToken, token)
    },
    setSsoConfig(state, config) {
      state.ssoConfig = config
      window.ssoConfig = config
    },
    removeToken(state) {
      state.token = null
      removeCache(cacheMode, eipToken)
    },
    setCurrentUser(state, user) {
      state.currentUser = user
    },
    setIsFirstLoad(state,  flag) {
      state.isFirstLoad = flag
    },
    setIsRefreshingToken(state, flag) {
      state.isRefreshingToken = flag
    },
    setLogo(state, url) {
      state.logo = url
    },
    setTenantCode(state, tenantCode) {
      state.tenantCode = tenantCode
      localStorage.setItem('tenantCode', tenantCode)
    },
    setTenantId(state, tenantId) {
      state.tenantId = tenantId
      localStorage.setItem('tenantId', tenantId)
    },
    setCurrentUser_refreshToken(state, token) {
      state.token = token
    },
    setCurrentUserDetail(state, detail) {
      state.currentUserDetail = detail
    },
    resetLoginStatus(state) {
      state.currentUser = null
      state.isFirstLoad = true
    },
  },
  actions: {
    /**
     * @description: 获取租户信息
     * @param commit
     * @param state
     * @param tenantCode 租户code
     */
    async getTenant({ commit, state }, tenantCode) {
      const res = await getTenantApi({
        code: tenantCode
      })
      const tenantManage = res.value
      commit('setTenantId', tenantManage.id || '-1')
      if (tenantManage.ico) {
        commit('setLogo', Api.getLogoFile + '?logoType=manage&tenantId=' + tenantManage.id)
      }
    },
    async getCurrentUserDetail({ commit, state }) {
      const res = await getUserDetailApi({
        accountOrId: state.currentUser.account
      })
      commit('setCurrentUserDetail', res)
    },
    /**
     * @description: 刷新token
     * @param commit
     * @param state
     */
    async refreshToken({ commit, state }) {
      if (state.isRefreshingToken) {
        return
      }
      commit('setIsRefreshingToken', true)
      const res = await refreshTokenApi()
      commit('setCurrentUser_refreshToken', res.token)
      commit('setIsRefreshingToken', false)
    },
    /**
     * @description: 通过ticket 认证并获取Token
     * @param commit
     * @param state
     * @param ticket 认证回跳时，url携带的ticket
     */
    async authenticate({ commit, state, dispatch }, ticket) {
      if (ticket) {
        const res = await ssoAuthApi({
          ticket: ticket,
          code: ticket,
          ssoMode: window.ssoConfig.mode,
          service: encodeURIComponent(window.location.href.split(/[&,?]((ticket|unified_token)=)/)[0])
        })
        const { token } = res
        commit('setToken', token)
      } else if (getCache(cacheMode, eipToken)) {
        commit('setToken', getCache(cacheMode, eipToken))
      } else {
        dispatch('toLogin')
      }
      
      // console.log(res)
      // commit('setLoginAccount', res.account)
      // commit('setCurrentUser', res)
    },
    // 金智认证
    async jzAuthenticate({ commit, dispatch }) {
      try {
        if (getCache(cacheMode, eipToken)) {
          commit('setToken', getCache(cacheMode, eipToken))
        } else {
          const res = await jzAuthApi({
            ssoMode: 'jzcas',
            service: encodeURIComponent(window.location.href.split(/[&,?]ticket=/)[0])
          })
          const { token, code } = res
          if (code === 401) {
            dispatch('toLogin')
            return
          }
          token && commit('setToken', token)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 获取当前登录用户信息
    async getCurrentUserInfo({ commit }) {
      try {
        const res = await getUserInfo()
        const { account, fullname, tenantId, userId } = res
        commit('setCurrentUser', { account, username: fullname, userAttrs: { tenantId }, userId })
        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    // 获取用户的登入登出配置
    async getSsoConfig({ commit }) {
      try {
        const res = await getSSOConfig()
        const { code, value } = res
        if (code === 200) {
          const { mode, serverName, serverLoginUrl, serverLogoutUrl } = value
          const url = serverLoginUrl
          const logout = serverLogoutUrl
          const titleConfig = serverName
          const clientId = value.clientId || ''
          commit('setSsoConfig', { mode, url, logout, titleConfig, clientId })
        }
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    /**
     * @description: 跳转到登录页
     * @param commit
     */
    async toLogin({ commit, state }) {
      commit('resetLoginStatus')
      commit('removeToken')
      console.log(state, 'state')
      if (state.ssoConfig && (state.ssoConfig.mode === 'cas' || state.ssoConfig.mode === 'jzcas')) {
        window.location.href = `${state.ssoConfig.url}?service=${encodeURIComponent(window.location.href)}`
      } else if (state.ssoConfig.mode === 'kyoauth') {
        window.location.href = `${state.ssoConfig.url}?redirect=${encodeURIComponent(window.location.href)}`
      } else if (state.ssoConfig && (state.ssoConfig.mode === 'oauth')) {
        const service = window.location.href
        window.location.href = `${state.ssoConfig.url}?response_type=code&client_id=${state.ssoConfig.clientId}&redirect_uri=${service}`
      } else {
        router.push({
          path: localStorage.getItem('loginRoutePath') || '/login'
        })
      }
    },
    /**
     * @description: 退出登录
     * @param commit
     */
    async toLogout({ commit, state }) {
      await logout()
      commit('resetLoginStatus')
      commit('removeToken')
      if (state.ssoConfig && (state.ssoConfig.mode === 'cas' || state.ssoConfig.mode === 'jzcas')) {
        window.location.href = `${state.ssoConfig.logout}?service=${encodeURIComponent(window.location.href)}`
      } else if (state.ssoConfig.mode === 'kyoauth') {
        window.location.href = `${state.ssoConfig.logout}?redirect=${encodeURIComponent(window.location.href)}`
      } else if (state.ssoConfig && (state.ssoConfig.mode === 'oauth')) {
        const service = window.location.href
        window.location.href = `${state.ssoConfig.url}?response_type=code&client_id=${state.ssoConfig.clientId}&redirect_uri=${service}`
      } else {
        await router.push({
          path: localStorage.getItem('loginRoutePath') || '/login'
        })
      }
    },
  }
}
